import React from 'react';
import { Outlet, ScrollRestoration } from 'react-router-dom';
import Footer from '../footer/Footer';
import Navbar from '../Navbar/Navbar';

function Root() {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow relative bg-skyline-bg text-skyline-text pt-16 lg:pt-20">
        <Outlet />
      </main>
      <Footer />
      {/* ScrollRestoration ensures page scroll goes to top on route change */}
      <ScrollRestoration />
    </div>
  );
}

export default Root;